import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function SlidersHotels({ section }) {

  function updateClassBasedOnScreenSize() {
    const element = document.querySelector(".hotels-page-margin"); // Ensure targeting the correct h3 element

    if (!element) return; // Exit if element is not found

    if (window.innerWidth >= 1024) {
      element.classList.add("mb-5");

    } else {
      element.classList.remove("mb-5");
    }

    const element_1 = document.querySelector(".hotels-page-pb3"); // Ensure targeting the correct h3 element

    if (!element_1) return;

    if (window.innerWidth >= 1024) {
      element_1.classList.add("pb-3");

    } else {
      element_1.classList.remove("pb-3");
    }
  }

  // Run on page load and when resizing
  window.addEventListener("load", updateClassBasedOnScreenSize);
  window.addEventListener("resize", updateClassBasedOnScreenSize);

  const [isScrolled, setIsScrolled] = useState(false);

  const settings = {
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: false,
    dots: false,
    pauseOnHover: false,
    responsive: [
      {
        breakpoint: 1024, // For screens smaller than 1024px
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 768, // For screens smaller than 768px
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 520, // For screens smaller than 520px
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  };

  const handleScroll = () => {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    setIsScrolled(scrollTop > 50);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);





  const fallbackItems = [
    { image_url: 'assets/img/hotels/1.png', description: 'Get flat 10% OFF* on ride with outstation one way or round trip cab bookings', subtitle: 'Valid till: 30th Nov, 2024' },
    { image_url: 'assets/img/hotels/2.png', description: 'Get flat 10% OFF* on ride with outstation one way or round trip cab bookings', subtitle: 'Valid till: 30th Nov, 2024' },
    { image_url: 'assets/img/hotels/3.png', description: 'Get flat 10% OFF* on ride with outstation one way or round trip cab bookings', subtitle: 'Valid till: 30th Nov, 2024' },
    { image_url: 'assets/img/hotels/4.png', description: 'Get flat 10% OFF* on ride with outstation one way or round trip cab bookings', subtitle: 'Valid till: 30th Nov, 2024' },
    { image_url: 'assets/img/hotels/6.png', description: 'Get flat 10% OFF* on ride with outstation one way or round trip cab bookings', subtitle: 'Valid till: 30th Nov, 2024' },
    { image_url: 'assets/img/hotels/7.png', description: 'Get flat 10% OFF* on ride with outstation one way or round trip cab bookings', subtitle: 'Valid till: 30th Nov, 2024' },
  ];
  const items = section?.Items?.length ? section.Items : fallbackItems;

  return (
    <div>
      <div className="container offers exclusive-officer-sec ">
        <div className="popular-state pb-0 pt-0 ">
          <div className="container">
            <div className="title text-center ">
              <h3 className="pb-0">{section?.title_highlight ? <span>{section.title_highlight} </span> : <span>Unlock Exclusive </span>}{section?.title || 'Deals and Savings'}</h3>
            </div>
          </div>
        </div>

        <div className={`customer-logos slider slides-wrapper slider-width ${isScrolled ? "slider" : ""}`}>
          <Slider {...settings}>
            {items.map((item, index) => (
              <div className="exclusive-offers-img-sec" key={`${item.image_url}-${index}`}>
                <img src={item.image_url} alt={item.title || 'Offer'} />
                <div className="_offrdtl">{item.description || item.title}</div>
                <div className="_offrdate">{item.subtitle || item.badge_text}</div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );
}

export default SlidersHotels;
